<template lang="pug">
.barcode-wrapper
  .error(
    v-if="error"
    v-text="error")
  component(
    v-else
    :is="tag"
    ref="barcode")
</template>

<script>
import * as JsBarcode from 'jsbarcode'
import numeral from 'numeral'
import { BARCODE_TYPES } from '~/settings'

export default {
  props: {
    value: {
      type: String,
      default: undefined
    },
    format: {
      type: String,
      default: undefined
    },
    tag: {
      type: String,
      default: 'canvas'
    }
  },

  data () {
    return {
      error: null
    }
  },

  computed: {
    barcodeFormatter () {
      switch (this.format) {
        case BARCODE_TYPES.UPC:
          return 'UPC'
        case BARCODE_TYPES.EAN:
          return 'EAN13'
        default:
          return this.format
      }
    },

    normalized () {
      return numeral(this.value).format('000000000000')
    },

    options () {
      return {
        format: this.barcodeFormatter,
        flat: false,
        fontOptions: 'bold',
        margin: 0
      }
    }
  },

  watch: {
    $props: {
      deep: true,
      immediate: true,
      handler () {
        this.generate()
      }
    }
  },

  mounted () {
    this.generate()
  },

  methods: {
    generate () {
      if (!this.$refs.barcode) return
      try {
        this.error = null
        JsBarcode(this.$refs.barcode, String(this.normalized), this.options)
      } catch (e) {
        this.error = 'Barcode Image not available'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.barcode-wrapper {
  width: 100%;
  text-align: center;
  > * {
    width: 100%;
  }
  svg {
    width: 100%;
  }
  .error {
    color: $--color-warning;
    font-size: 12px;
  }
}
</style>
